import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';

import ScrollToTop from './ScrollToTop';
import Header from '../app/components/Header/Header';
import Dashboard from '../app/views/Dashboard/Dashboard';
import Message from '../app/views/Message/Message';
import Settings from '../app/views/Settings/Settings';
import PendingMessages from '../app/views/PendingMessages/PendingMessages';
import ActivityMap from '../app/views/ActivityMap/ActivityMap';
import Constituents from '../app/views/Constituents/Constituents';
import ConstituentPage from '../app/views/ConstituentPage/ConstituentPage';
import CaseTable from '../app/views/CaseTable/CaseTable';
import CasePage from '../app/views/CasePage/CasePage';
import FileTable from '../app/views/FileTable/FileTable';

import { USER_ROLES } from './constants/AppConstants';

const AppRoutes = ({ sessionState, userInfo }) => {
  const action = useSelector((state) => state.action);

  const [loggingIn, setLoggingIn] = useState(false);
  const [loginAttempt, setLoginAttempt] = useState(false);

  const mppRoleValue = USER_ROLES.find((role) => role.short === 'MPP').value;
  const councilorRoleValue = USER_ROLES.find((role) => role.short === 'Councillor').value;

  const isMpp = userInfo && userInfo.role === mppRoleValue;
  const isCouncillor = userInfo && userInfo.role === councilorRoleValue;

  useEffect(() => {
    if (action.loggingIn) {
      setLoginAttempt(true);
      setLoggingIn(true);
      return;
    }
    setLoginAttempt(false);
    setLoggingIn(false);
  }, [action]);

  if (!userInfo) {
    return null;
  }

  return (
    <div className={loggingIn ? 'blur-frame' : !loginAttempt && !sessionState ? 'hidden' : ''}>
      <Router>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Header />}>
            <Route
              index
              element={
                isMpp || isCouncillor ? <Navigate to="/activity_map" replace /> : <Navigate to="/emails" replace />
              }
            />
            <Route path="emails" element={<Dashboard />} />
            <Route path="email/:id" element={<Message />} />
            <Route path="activity_map" element={<ActivityMap />} />
            <Route path="pending_emails" element={<PendingMessages />} />
            <Route path="settings" element={<Settings />} />
            <Route path="constituents" element={<Constituents />} />
            <Route path="constituent/:id" element={<ConstituentPage />} />
            <Route path="cases" element={<CaseTable />} />
            <Route path="case/:id" element={<CasePage />} />
            <Route path="files" element={<FileTable />} />
          </Route>
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      </Router>
    </div>
  );
};

export default AppRoutes;
